import DataReport from './index'
import UserContractAssetMonitor from '../UserContractAssetMonitor'
import UserDataStatistic from '../UserDataStatistic'

export default {
  path: '/home/dataReport',
  component: DataReport,
  meta: { titie: '数据报表' },
  children: [
    {
      path: '/home/dataReport/userDataStatistic',
      component: UserDataStatistic,
      meta: { titie: '用户数据统计表' },
    },
    {
      path: '/home/dataReport/userContractAssetMonitor',
      alias: '/home/userContractAssetMonitor',
      component: UserContractAssetMonitor,
      meta: { titie: '用户合约交易与资产监控表' },
    },
  ],
}
